let sequence = 0
let cancelPendingScan = null

export function isEmbeddedPage () {
  return window.self !== window.top
}

export function needsParentWechat () {
  return isEmbeddedPage()
}

export function scanByParent () {
  if (cancelPendingScan) cancelPendingScan()
  return new Promise((resolve, reject) => {
    let origin
    try {
      origin = new URL(document.referrer).origin
      if (!/^https?:\/\//.test(origin)) throw new Error('invalid origin')
    } catch (error) {
      reject(new Error('无法识别外层页面，请对接方为 iframe 设置 referrerpolicy="origin"'))
      return
    }
    const requestId = Date.now() + '-' + (++sequence)
    let timer
    let finished = false
    const finish = (error, value) => {
      if (finished) return
      finished = true
      if (cancelPendingScan === cancel) cancelPendingScan = null
      window.clearTimeout(timer)
      window.removeEventListener('message', receive)
      window.removeEventListener('pagehide', leave)
      if (error) reject(error)
      else resolve(value)
    }
    const cancel = () => finish(null, null)
    cancelPendingScan = cancel
    const leave = () => finish(new Error('页面已离开，扫码已取消'))
    const receive = event => {
      const data = event.data
      if (event.source !== window.parent || event.origin !== origin || !data) return
      // 兼容父页直接回传二维码原文，后续仍由问卷校验链接格式。
      if (typeof data === 'string') {
        if (data.trim()) finish(null, data.trim())
        return
      }
      if (data.requestId != null && data.requestId !== requestId) return
      if (data.type === 'SCAN_RESULT' && data.status === 'cancel') {
        finish(null, null)
        return
      }
      if (data.type === 'SCAN_RESULT' && typeof data.data === 'string') {
        console.info('[wpc-h5] SCAN_RESULT received', { requestId, cancelled: !data.data.trim() })
        finish(null, data.data.trim() || null)
        return
      }
      if (data.requestId !== requestId) return
      if (data.type === 'SCAN_RESULT') {
        if (data.status === 'cancel') finish(null, null)
        else if (data.status === 'ok' && typeof data.resultStr === 'string') finish(null, data.resultStr)
        else finish(new Error(typeof data.message === 'string' ? data.message : '外层页面扫码失败'))
      }
    }
    window.addEventListener('message', receive)
    window.addEventListener('pagehide', leave)
    timer = window.setTimeout(() => finish(new Error('外层页面未返回扫码结果，请确认已接入扫码通信后重试')), 90000)
    try {
      window.parent.postMessage({ type: 'SCAN_REQUEST', requestId }, origin)
      console.info('[wpc-h5] SCAN_REQUEST sent', { requestId, origin })
    } catch (error) {
      finish(error)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/parentWechat.js